import React, { useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  TextField,
  MenuItem,
} from "@mui/material";
import { archivedProjects } from "../data/ArchivedProjectsData";

export default function ArchivedProjects() {
  const [titleFilter, setTitleFilter] = useState("");
  const [departmentFilter, setDepartmentFilter] = useState("");
  const [leadFilter, setLeadFilter] = useState("");
  const [impactFilter, setImpactFilter] = useState("");

  const filteredProjects = archivedProjects.filter((project) => {
    return (
      project.title.toLowerCase().includes(titleFilter.toLowerCase()) &&
      (departmentFilter === "" || project.department === departmentFilter) &&
      (leadFilter === "" || project.lead === leadFilter) &&
      (impactFilter === "" || project.impact === impactFilter)
    );
  });

  const uniqueDepartments = [
    ...new Set(archivedProjects.map((p) => p.department)),
  ];
  const uniqueLeads = [...new Set(archivedProjects.map((p) => p.lead))];
  const uniqueImpacts = [...new Set(archivedProjects.map((p) => p.impact))];

  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          Archived Projects Report
        </Typography>
        <TextField
          label="Filter by Title"
          variant="outlined"
          size="small"
          sx={{ mr: 2 }}
          value={titleFilter}
          onChange={(e) => setTitleFilter(e.target.value)}
        />
        <TextField
          label="Department"
          variant="outlined"
          size="small"
          select
          sx={{ mr: 2 }}
          value={departmentFilter}
          onChange={(e) => setDepartmentFilter(e.target.value)}
        >
          <MenuItem value="">All</MenuItem>
          {uniqueDepartments.map((dept) => (
            <MenuItem key={dept} value={dept}>
              {dept}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          label="Project Lead"
          variant="outlined"
          size="small"
          select
          sx={{ mr: 2 }}
          value={leadFilter}
          onChange={(e) => setLeadFilter(e.target.value)}
        >
          <MenuItem value="">All</MenuItem>
          {uniqueLeads.map((lead) => (
            <MenuItem key={lead} value={lead}>
              {lead}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          label="Impact"
          variant="outlined"
          size="small"
          select
          value={impactFilter}
          onChange={(e) => setImpactFilter(e.target.value)}
        >
          <MenuItem value="">All</MenuItem>
          {uniqueImpacts.map((impact) => (
            <MenuItem key={impact} value={impact}>
              {impact}
            </MenuItem>
          ))}
        </TextField>
      </Box>
      <Paper sx={{ width: "100%", overflowX: "auto" }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
              <TableCell>
                <strong>#</strong>
              </TableCell>
              <TableCell>
                <strong>Project Title</strong>
              </TableCell>
              <TableCell>
                <strong>Department</strong>
              </TableCell>
              <TableCell>
                <strong>Project Lead</strong>
              </TableCell>
              <TableCell>
                <strong>Completed On</strong>
              </TableCell>
              <TableCell>
                <strong>Impact</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredProjects.map((project, index) => (
              <TableRow key={project.id} hover>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{project.title}</TableCell>
                <TableCell>{project.department}</TableCell>
                <TableCell>{project.lead}</TableCell>
                <TableCell>{project.completedOn}</TableCell>
                <TableCell>{project.impact}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
}
